import { Box, CircularProgress, Typography } from "@deere/fuel-react";
export const ProgressIndicator = ({ title, subtitle, displayProcessIndicador }) => {
    return (
        <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
            height={200}
            justifyContent="center"
            p={4}
        >
            {
               displayProcessIndicador ? <CircularProgress /> : null
            }
            <Typography
                gutterBottom
                style={{
                    marginTop: "1rem",
                }}
                variant="h3"
            >
                {title}
            </Typography>
            <Typography variant="subtitle2">
                {subtitle}
            </Typography>
        </Box>
    );
}